'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import React, { useMemo } from 'react';
import LinkButton from '@/components/atoms/LinkButton';
import ArrowRightIcon from '@/public/assets/svg/arrow-right.svg';
import { CryptoTableType } from '@/utils/types';
import ChangeIndicator from '../MobileCrypto/partials/ChangeIndicator';
const TableBody = t0 => {
  const $ = _c(10);
  const {
    variant,
    howToButtonLabel,
    rows
  } = t0;
  let t1;
  if ($[0] !== rows || $[1] !== variant) {
    t1 = variant == "buyTable" ? rows?.map(_temp) || [] : rows?.map(_temp2) || [];
    $[0] = rows;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const centerRows = t1;
  let t2;
  if ($[3] !== centerRows || $[4] !== howToButtonLabel || $[5] !== rows || $[6] !== variant) {
    t2 = rows?.map((row, index) => <tr className="child:h-[inherit] child:p-0 first:child:child:border-t-0 first:child:border-t child:first:border-l child:first:pl-6 last:child:border-b child:last:pr-6 h-18 border-gray-200" key={row.ticker}><td><div className="flex h-full items-center gap-x-3 border-t"><PrismicNextImage fallbackAlt="" width={28} height={28} field={row.icon} />{`${row.label} (${row.ticker}/${row.currencyCode})`}</div></td>{centerRows[index]?.map((item_1, cellIndex) => <td key={`${row.ticker}-${cellIndex}`}><div className="flex h-full items-center border-t">{item_1}</div></td>)}<td><ChangeIndicator change={row.change} className="border-t" /></td><td className="border-r"><div className="h-full border-t py-3.5!"><LinkButton variant="outline" className="ml-auto max-w-44" field={variant === "buyTable" || variant === "buyFeesAndLimits" ? row.buyLink : row.sellLink}>{howToButtonLabel?.(row.ticker || "")} <ArrowRightIcon className="h-6 w-6" /></LinkButton></div></td></tr>);
    $[3] = centerRows;
    $[4] = howToButtonLabel;
    $[5] = rows;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <tbody className="shadow-elevation-3 before:block before:h-4" data-sentry-component="TableBody" data-sentry-source-file="index.tsx">{t2}</tbody>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default TableBody;
function _temp(item) {
  return [item.buyValue, item.buyFeeFlat];
}
function _temp2(item_0) {
  return [item_0.sellValue];
}